export function identityFormSubmission(
  form,
  submitter,
  FormDataImpl = globalThis.FormData,
) {
  if (!form || typeof FormDataImpl !== "function") {
    throw new TypeError("Identity form submission is unavailable.");
  }
  const formData = new FormDataImpl(form, submitter ?? undefined);

  const submission = new URLSearchParams();
  for (const [name, value] of formData) {
    if (typeof value !== "string") {
      throw new TypeError("Identity forms cannot submit binary values.");
    }
    submission.append(name, value);
  }
  return submission;
}
